/** Given-name aliases for matching. Bidirectional. Not an LLM. */
const GIVEN_NAME_GROUPS = [
  ["aaron", "erin"],
  ["abigail", "abby", "gail"],
  ["albert", "al", "bert"],
  ["alexander", "alex", "al"],
  ["andrew", "andy", "drew"],
  ["ann", "anne", "anna", "annie"],
  ["anthony", "tony"],
  ["barbara", "barb", "babs"],
  ["benjamin", "ben", "benny"],
  ["catherine", "cathy", "kate", "kathy", "katie"],
  ["charles", "charlie", "chuck", "chas"],
  ["christopher", "chris"],
  ["daniel", "dan", "danny"],
  ["david", "dave", "davey"],
  ["deborah", "debbie", "deb"],
  ["donald", "don", "donnie"],
  ["edward", "ed", "eddie", "ted", "teddy"],
  ["elizabeth", "liz", "beth", "betsy", "betty", "eliza"],
  ["eugene", "gene"],
  ["frances", "fran", "frannie"],
  ["frederick", "fred", "freddy"],
  ["gregory", "greg"],
  ["harold", "harry", "hal"],
  ["helen", "ellen"],
  ["henry", "hank", "harry"],
  ["james", "jim", "jimmy", "jamie"],
  ["jeffrey", "jeff"],
  ["jennifer", "jen", "jenny"],
  ["john", "jack", "johnny"],
  ["jonathan", "jon", "john"],
  ["joseph", "joe", "joey"],
  ["joshua", "josh"],
  ["judith", "judy"],
  ["katherine", "kate", "kathy", "katie", "cathy"],
  ["kenneth", "ken", "kenny"],
  ["lawrence", "larry"],
  ["leonard", "leo", "len"],
  ["margaret", "maggie", "meg", "peggy", "marge"],
  ["matthew", "matt"],
  ["michael", "mike", "mick", "mickey"],
  ["nicholas", "nick", "nicky"],
  ["patricia", "pat", "patty", "trish"],
  ["patrick", "pat", "paddy"],
  ["peter", "pete"],
  ["philip", "phil"],
  ["raymond", "ray"],
  ["rebecca", "becky", "becca"],
  ["richard", "rick", "ricky", "dick", "rich"],
  ["robert", "rob", "bob", "bobby", "bert"],
  ["ronald", "ron", "ronnie"],
  ["russell", "russ"],
  ["samuel", "sam", "sammy"],
  ["stephen", "steven", "steve", "stevie"],
  ["susan", "sue", "susie", "suzy"],
  ["teresa", "terry", "terri", "tess"],
  ["thomas", "tom", "tommy"],
  ["timothy", "tim", "timmy"],
  ["victoria", "vicky", "vicki"],
  ["vincent", "vince"],
  ["virginia", "ginny", "ginger"],
  ["walter", "walt"],
  ["william", "will", "bill", "billy", "liam", "willy"],
];

const aliasMap = (() => {
  const map = new Map();
  GIVEN_NAME_GROUPS.forEach((group) => {
    group.forEach((name) => {
      const current = map.get(name) || new Set();
      group.forEach((alias) => current.add(alias));
      map.set(name, current);
    });
  });
  return map;
})();

export const givenNameAliases = (givenName) => {
  const key = String(givenName || "")
    .toLowerCase()
    .trim();
  if (!key) return [];
  const aliases = aliasMap.get(key);
  if (!aliases) return [key];
  return [...aliases];
};
